import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

export type ConditionProps = {
    label: string;
    displayName?: string;
    onClick: () => void;
    logicCondition?: boolean;
};

export const StyledCondition = styled.div`
    padding: 10px;
    border: 1px dashed gray;
    border-radius: 3px;
    display: flex;
    gap: 5px;
`;

const StyledConditionLabel = styled.div`
    align-self: center;
    width: 100%;
`;

export const Condition = ({ label, onClick, logicCondition, displayName }: ConditionProps) => (
    <StyledCondition>
        <StyledConditionLabel>
            <Trans
                components={{
                    bold: <strong />,
                }}
                i18nKey={label}
            />
        </StyledConditionLabel>
        {logicCondition ? (
            <Button
                className="action"
                icon={<EditOutlined />}
                onClick={onClick}
                style={{ alignSelf: 'center' }}
                type="link"
            />
        ) : (
            <Button
                className="action"
                icon={<DeleteOutlined />}
                onClick={onClick}
                style={{ alignSelf: 'center' }}
                type="link"
            />
        )}
    </StyledCondition>
);
